import React from 'react';

export const ConfiguracaoSistemaContexto = React.createContext(null);